/**
 * 受保护的路由组件
 * 需要登录才能访问
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  console.log('ProtectedRoute检查:', {
    pathname: location.pathname,
    hasToken: !!token,
    hasUser: !!user,
    tokenLength: token?.length,
    userLength: user?.length
  });

  if (!token || !user) {
    console.warn('ProtectedRoute: 未登录，重定向到登录页', {
      hasToken: !!token,
      hasUser: !!user,
      currentPath: location.pathname
    });
    // 未登录，重定向到登录页，并传递当前页面信息以便登录后跳转回来
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  console.log('ProtectedRoute: 验证通过，允许访问');
  return children;
};

export default ProtectedRoute;
